import React from "react";
import Bg from "./images/background.png";
import Icon1 from "./images/iconsBG1.png";
import Icon2 from "./images/iconsBG2.png";
import Icon3 from "./images/iconsBG3.png";
import Icon4 from "./images/iconsBG4.png";

const KeyInsights = () => {
  const insights = [
    {
      icon: Icon1,
      title: "AI Workplace",
      description:
        "AI is reshaping industries by automating tasks and enhancing data analysis, leading to greater efficiency and innovative solutions in sectors like healthcare and finance",
    },
    {
      icon: Icon2,
      title: "Transition Stories",
      description:
        "Share your journey and gain insights from others who have successfully transitioned in their careers. Learn from their experiences to inspire your own path forward",
    },
    {
      icon: Icon3,
      title: "Skill Development",
      description:
        "Explore a wide range of courses, certifications, and learning resources to elevate your skills. Equip yourself with the knowledge needed to advance your career ",
    },
    {
      icon: Icon4,
      title: "Job Opportunities",
      description:
        "Discover job openings and connect with opportunities within the community. Share leads to support each other in finding the right career paths",
    },
  ];
  return (
    //parent div
    <div
      className="flex flex-col items-center justify-center min-h-screen pt-4"
      style={{
        backgroundImage: `url(${Bg})`,
        background: "cover",
      }}
    >
      {/* {child div 1} */}
      <div className="flex justify-center mb-8">
        {" "}
        {/* Adds margin-bottom */}
        <h1 className="text-lg sm-text-xl md:text-2xl lg:text-3xl font-bold text-center text-custom-blue max-w-[590px]">
          Join the Conversation on Key Industry Insights and Innovations
        </h1>
      </div>

      {/* child div 2 */}
      <div className="grid gap-6 p-4 grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 justify-center">
        {insights.map((card, index) => (
          <div
            key={index}
            className="flex flex-col items-center bg-white rounded-xl shadow-lg w-full sm:w-52 md:w-56 lg:w-64 hover:scale-105 hover:shadow-2xl transition-transform p-6 space-y-4"
          >
            <div className="rounded-full flex items-center justify-center">
              <img src={card.icon} alt="icon" className="w-14 h-14" />
            </div>

            <h1 className="font-bold text-center text-md sm-text-lg md:text-lg lg:text-xl">
              {card.title}
            </h1>
            <p className="text-center font-normal text-sm text-border-gray lg:text-base">
              {card.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KeyInsights;
